import * as React from "react";
import { useState } from "react";
import temperatureIcon from "../../../../../assets/images/icons/temperature.png";
import humidityIcon from "../../../../../assets/images/icons/humidity.png";
import { getKits } from "src/services/corporateService";
import ProjectService from "src/app/project/ProjectService";
import { SensorIcon } from "src/app/polar-SAAS-Components/components/Icons";
import {setQueryParam} from 'src/app/polar-SAAS-Components/utilsNew';
import Toggle from "src/app/polar-SAAS-Components/components/Toggle";
import { Range  , getTrackBackground } from "react-range";
import  authService  from "src/app/polar-SAAS-Components/auth-service";
import useStyleClasses from "src/app/polar-SAAS-Components/style";
import Toaster from "src/app/polar-SAAS-Components/components/Toaster";
import { useIsMobile } from "../../../../polar-SAAS-Components/utilsNew";

const KitsConfiguration = () => {
    const isMobile = useIsMobile(768);
    const styleClasses=useStyleClasses(isMobile)

  const [alertThresholds, setAlertThresholds] = useState({
    alertAfter: "1",
    persistenceType: "",
    alertNextLevelAfter: "10",
  });

  const [underMaintenance, setUnderMaintenance] = useState(false);
  const [persistenceDevice, setPersistenceDevice] = useState(false);
  const [suppressAlerts, setSuppressAlerts] = useState(false);
  const [defrostInterval,setDefrostInterval]=useState("")

  const persistenceTypes = ["CONTINUOUS", "INTERVAL", "SQUARE"];

  const [maintenanceHistory, setMaintenanceHistory] = useState([]);
  const [kitId, setKitId] = useState(""); 
  const [kitToConfigure, setKitToConfigure] = useState(
    { id:"",
      name:"",
      properties:[],
      alerts:[],
      alertLevel:1
    }
  );

  const [properties,setProperties]=useState([]);

  const [currentSelectedProperty, setCurrentSelectedProperty] = useState(0);
  
  const [kitsForUser, setKitsForUser] = useState([]);
  const [error, setError] = useState({ error: false, message: "" });

  const [alerts, setAlerts] = useState<any[]>([]);
  const [alertsOriginal, setAlertsOriginal] = useState<any[]>([]);

  const [alertLimitHistory, setAlertLimitHistory] = useState<any[]>([]);
  const [alertToggleHistory, setAlertToggleHistory] = useState<any[]>([]);
  const [isAllFetchedThreshold, setIsAllFetchedThreshold] = useState(false);
  const [isAllFetchedAlertToggle, setIsAllFetchedAlertToggle] = useState(false);
  const [isFetchingDataThreshold, setIsFetchingDataThreshold] = useState(false);
  const [isFetchingAlertToggle, setIsFetchingAlertToggle] = useState(false);

    const [openToaster,setopenToaster]=useState(false);
    const [msg,setMsg]=useState("");
    const [success,setSuccess]=useState(true);

  const [currentOpenAccordion, setCurrentOpenAccordion] = useState(1);
  const alertConfigDisabled=authService.getRole()>1000;

  const propertyIcons = {
    'T': temperatureIcon,
    'H':  humidityIcon,
    "Default": SensorIcon
  
  };
  const [loading, setLoading] = useState(false);

  const numberOfThresholdHistoryPerPage=6;
  const projectService = new ProjectService();

  React.useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const kitIdFromParams = queryParams.get("id");

    // Fetch kits for the user and update state
    const fetchKits = async () => {
      try{
      const response = await getKits();
      console.log("Kits fetched:", response);
      if (response.status === 200 && response.data.content) {
        const kitsWithData = response.data.content.filter((kit) => kit.properties && kit.properties.length > 0);
        setKitsForUser(kitsWithData);
        setError({ error: false, message: "" });
      }
      else if (response.status == 422) {
        setError({ error: true, message: response.data.message || "Failed to get Entities" });
        setKitsForUser([]);
      }
      else {
        setError({ error: true, message: response.data.message || "Failed to get Entities" });
        setKitsForUser([]);
      }}
      catch(error){
        console.log(error)
      }
    }
    fetchKits();
      if (kitIdFromParams) {
      setKitId(kitIdFromParams);
      getKit(kitIdFromParams);
    }
  
  }, []);

  const onSliderChange = (level,value) => {

    setAlerts(prevAlerts => {
    return prevAlerts.map(alert => {
      if (alert.level === level) {
        return {
          ...alert,
          isDragging:true,
          low: value[0],
          high: value[1]
        };
      }
      return alert;
    });
  });
   setTimeout(() =>    setAlerts(prevAlerts => {
    return prevAlerts.map(alert => {
      if (alert.level === level) {
        return {
          ...alert,
          isDragging:false,
        };
      }
      return alert;
    });
  }), 1000);
  }


  const handleAlertThresholdChange = (field, value,level) => {
    setAlerts(prevAlerts => {
    return prevAlerts.map(alert => {
      if (alert.level === level) {
        return {
          ...alert,
          [field]: value,
        };
      }
      return alert;
    });
  })
  };
  const handleKitSelect = ( value) => {
    setKitId(value);
    setQueryParam("id", value);
    getKit(value);
  };



  const toggleThresholdSettings = async(level,currentStatus) => {
    const updateStatus=!currentStatus;
    updateAlert(level,updateStatus);
      setKitToConfigure(prev => ({
    ...prev,
    alerts: {
      ...prev.alerts,
      [level]: updateStatus
    }
  }));
    if(updateStatus){
    setCurrentOpenAccordion(level);}
    
  };

  const handleAccordian=(level)=>{
    if(currentOpenAccordion==level){
      setCurrentOpenAccordion(undefined);
    }
    else {
    setCurrentOpenAccordion(level)
    }

  }

  const handleMaintenanceToggle = async (e) => {
    const updateStatus=!underMaintenance;
    try{
      const response=await projectService.updateKitMaintenanceStatus(kitId, { maintain:updateStatus });
      if (response.status===200){
        setUnderMaintenance(updateStatus);
        setMsg("maintenance status updated successfully!");
        setSuccess(true);
        setopenToaster(true);
        setTimeout(function () {
          setopenToaster(false);
        }, 5000);
      }
    }
    catch(error){
        setMsg("Error updating maintenance status");
        setSuccess(false);
        setopenToaster(true);
        setLoading(false);
        setTimeout(function () {
          setopenToaster(false);
        }, 5000);

      
      console.log('error updating maintenance ',error)
    }
  };

  const handleSuppressAlertsToggle = () => {
    if(suppressAlerts){
      //need to add confirm dialogs
      updateSupressAlert(false);
     
   }
    setSuppressAlerts(!suppressAlerts);
    
    
  }
  const handleUpdateSupressAlert=()=>{
      updateSupressAlert(true);
  }

  const handlePersistenceToggle = async(e) => {  
    const updateStatus=!persistenceDevice;
    try{
      const response=await projectService.updateKitPersistenceDeviceStatus(kitId, { persistence:updateStatus });
      console.log('persistence',response)
      if (response.status === 200) {
        console.log('update toggle')
        console.log(updateStatus)
        setPersistenceDevice(updateStatus);
        setMsg("Peristance of Device successfully updated!");
        setSuccess(true);
        setopenToaster(true);
        setTimeout(function () {
          setopenToaster(false);
        }, 5000);
      }
    }
    catch (error) {
      setSuccess(false);
      setMsg("Error updating device peristance");
      setopenToaster(true);
      setTimeout(function () {
        setopenToaster(false);
      }, 5000);
    }

  }
  const handlePropertyClick = async(property) => {
    
    try{
      await getAlertLimitForProperty(kitId,property,kitToConfigure.alertLevel);
      await getAlertLimitForPropertyHistory(0, Number(kitId), numberOfThresholdHistoryPerPage,property);
      setCurrentSelectedProperty(property);
    }
    catch(err){
        console.error('error fetching kit properties',err);
    }
    finally{

    }
  };
   const handleUpdateAlertLimit = async (alert) => {
     setLoading(true);
     try {
       const response = await projectService.updateKitAlertLimit(
         kitId,
         currentSelectedProperty,
         alert
       );
       if (response.status == 200) {
         setMsg("alert limit for kit updated successfully!");
         setSuccess(true);
         setopenToaster(true);
         setTimeout(function () {
           setopenToaster(false);
         }, 5000);
         handlePropertyClick(currentSelectedProperty);
       }
     } catch (err) {
       setSuccess(false);
       setMsg("Error updating kit alert limit");
       setopenToaster(true);
       setTimeout(function () {
         setopenToaster(false);
       }, 5000);
     }
     finally {
       setLoading(false);
     }
  }
   const handleResetAlertLimit = async (alert) => {
    setLoading(true);
        setAlerts(prevAlerts => {
    return prevAlerts.map(alertUpdated => {
      if (alertUpdated.level === alert.level) {
        return {
          ...alertsOriginal.filter(a => a.level === alert.level)[0]
        };
      }
      return alert;
    });
  });
    
  }


  // ---- fetch entity ----
  const getKit = async (kitId) => {
    setLoading(true);
    try {
      const response = await projectService.getKit( kitId);
      console.log("Kit fetched:", response);
      const kit = response.data.content;
      setKitToConfigure(kit);

      setCurrentSelectedProperty(0);
      console.log('got properties', kit.properties);
      setProperties(kit.properties);


      await getAlertLimitForProperty(kitId,0,kit.alertLevel);
      await getAlertLimitForPropertyHistory(0,kitId, numberOfThresholdHistoryPerPage,0);
      await getAlertToggleForPropertyHistory(0,kitId,numberOfThresholdHistoryPerPage)
      await getMaintenanceHistory(kitId,0,5);
      
      setUnderMaintenance(kit.maintain);
      setPersistenceDevice(kit.persistence);
      setSuppressAlerts(kit.stopAlertDefrost);
      if(kit.stopAlertDefrost){
        setDefrostInterval(kit.defrostInterval)
      }
    } catch (err) {
      console.error('error fetching kit properties',err);
    } finally {
      setLoading(false);
    }
  };

  // ---- fetch alert limits ----
  const getAlertLimitForProperty = async (kitId, propertynum, alertLevel) => {
    setLoading(true);
    try {
      const response = await projectService.getAlertLimitForProperty(
        kitId,
        propertynum
      );

      let alertsData = response.data.content;
      console.log('alert data for  kit',alertsData)
      let alertsOriginalData = JSON.parse(JSON.stringify(alertsData));
      console.log("alert level",alertLevel, alertsData.length)
      if (alertsData.length !== alertLevel) {
   
        const diff = alertLevel - alertsData.length;
        const length = alertsData.length;
        for (let i = 0; i < length; i++) {
          console.log("set alert data old ", alertsData[i])
          alertsData[i].minRange = alertsData[i].low -10;
          alertsData[i].maxRange = alertsData[i].high +10;
        }

        for (let i = 0; i < diff; i++) {
          const newAlert = { level: length + i + 1, low: 0, high: 0 ,minRange:0,maxRange:0,isDragging:false};
          alertsData.push(newAlert);
           console.log("set alert data ", alertsData)
          alertsOriginalData.push({ ...newAlert });
        }
       
      }
      console.log("setting alert data", alertsData)
      setAlerts(alertsData);
      setAlertsOriginal(alertsOriginalData);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // ---- fetch alert limit history ----
  const getAlertLimitForPropertyHistory = async (
    offset: number,
    kitId: number,
    entityCount: number,
    propertyNum:number,
    spinner = true
  ) => {
    if (spinner) setLoading(true);
    setIsFetchingDataThreshold(true);

    try {
      const response =
        await projectService.getAlertLimitForPropertyHistory(
          kitId,
          propertyNum,
          offset,
          entityCount
        );
   
      if (response.data.content.length < entityCount) {
        setIsAllFetchedThreshold(true);
      }

      setAlertLimitHistory((prev) =>
        prev ? prev.concat(response.data.content) : response.data.content
      );
    } catch (err) {
      console.error(err);
    } finally {
      if (spinner) setLoading(false);
      console.log('fetched alert limit history',alertLimitHistory);
      setIsFetchingDataThreshold(false);
    }
  };

    const getAlertToggleForPropertyHistory = async (
    offset: number,
    kitId: number,
    entityCount: number,
    spinner = true
  ) => {
    if (spinner) setLoading(true);
     setIsFetchingAlertToggle(true);

    try {
      const response =
        await projectService.getAlertToggleHistory(
          kitId,
          offset,
          entityCount
        );
   
      if (response.data.content.length < entityCount) {
          setIsAllFetchedAlertToggle(true);
      }

      setAlertToggleHistory((prev) =>
        prev ? prev.concat(response.data.content) : response.data.content
      );
    } catch (err) {
      console.error(err);
    } finally {
      if (spinner) setLoading(false);
      console.log('fetched alert limit history',alertToggleHistory);
    setIsFetchingAlertToggle(false);
    }
  };
    const getMaintenanceHistory = async (
    kitId,
    offset,
    entityCount,
  ) => {
    setLoading(true);
    try {
      const response =
        await projectService.getMaintenanceHistory(
          kitId,
          offset,
          entityCount,
        );
      setMaintenanceHistory((prev) =>
        prev ? prev.concat(response.data.content) : response.data.content
      );
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      console.log('fetched maintenance history',maintenanceHistory);
    }
  };
  const updateAlert=async(level,status)=>{
        const alertVar = {};
        alertVar[level] = status;
        try{
        setLoading(true);
        const response=await projectService.updateAlertStatus(kitId,{alerts:alertVar})
          if (response.status == 200) {
            setMsg("alert threshold updated successfully!");
            setSuccess(true);
            setopenToaster(true);
            setTimeout(function () {
              setopenToaster(false);
            }, 5000);
        }
      }
      catch(error){
        setMsg("Error updating alertThreshold");
        setSuccess(false);
        setopenToaster(true);
        setLoading(false);
        setTimeout(function () {
          setopenToaster(false);
        }, 5000);

      }
      finally{
        setLoading(false);
      }

  }
    const updateSupressAlert=async(suppress)=>{

        try{
        const response=await projectService.updateKitSuppressAlert(kitId,
          { stopAlertDefrost: suppress,
            ...suppress&&{defrostInterval: defrostInterval}})
      }
        catch(error){
        setMsg("Error updating suppress alert");
        setSuccess(false);
        setopenToaster(true);
        setLoading(false);
        setTimeout(function () {
          setopenToaster(false);
        }, 5000);

      }
      finally{}

  }

  return (
    <div style={styleClasses.kitLayout}>
      {/* Left Panel */}

      <div style={styleClasses.kitLeftPanel}>
        {authService.hasKitUpdateAccess() &&
        <><div style={{ display: "flex", gap: "20px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              fontSize: "12px",
              color: "#324054",
              width: "40%",
              height: "36px",
            }}
          >
            Kit Name
          </div>
          <select
            value={kitId}
            onChange={(e) =>
              handleKitSelect( e.target.value)
            }
            style={{
              width: "60%",
              height: "36px",
              padding: "8px 12px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              fontSize: "14px",
              backgroundColor: "white",
              color: alertThresholds.persistenceType ? "#324054" : "#868DAA",
              outline: "none",
              // 👇 NEW: limit dropdown height
              maxHeight: "200px", // fits ~6-7 items
              overflowY: "auto",
            }}
          >
            <option value="" disabled hidden>
              Select Kit
            </option>
            {kitsForUser.map((kit) => (
              <option key={kit.id} value={kit.id}>
                {kit.name}
              </option>
            ))}
          </select>
        </div>


        {kitsForUser&&kitsForUser.length==0&&
            <div style={{ padding: "10px 18px", textAlign: "center", color: "#868DAA" }}>
              No kits with sensor data found for configuration.
            </div>}
        </>}

        <div style={{ display: "flex", gap: "20px" , flexDirection:isMobile?"column":"row" }}>
          {properties.length>0 && 
          properties.map((property, index) => (
            <div
            style={{
              flex: "1",
              backgroundColor: currentSelectedProperty === property.number ? "#F0F7FF" : "#E2E5ED",
              borderRadius: "4px",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              padding: "20px",
              cursor: "pointer",
              border: currentSelectedProperty ===property.number? "1px solid #3b82f6" : "1px solid transparent",
              maxWidth:"300px"
            }}
            onClick={() => handlePropertyClick(property.number)}
          >
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginBottom: "12px",
              fontSize: "14px",
              fontWeight: 500
            }}>
              <div style={{
                width: "20px",
                height: "20px",
                backgroundColor: "#E2E5ED",
                borderRadius: "2px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                {propertyIcons[property.code]?<img src={propertyIcons[property.code]} alt={property.displayName} style={{ width: "12px", height: "22px" }} />:propertyIcons.Default}
              </div>
              {property.displayName}
            </div>
            <div style={{
              fontSize: "32px",
            }}>{property.value}</div>
          </div>))}
        </div>
      
         {kitToConfigure.id &&(<>
        <h3 style={{
          fontSize: "16px",
          fontWeight: 600,
          color: "#324054"
        }}>Alert Thresholds</h3>

        {/* Alert Thresholds section */}
        <div style={{
          backgroundColor: "white",
          borderRadius: "6px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        }}>
          <div style={alertConfigDisabled ? styleClasses.disabledContainer : {}}>
            <fieldset disabled={alertConfigDisabled} style={styleClasses.fieldsetStyle}>
            {alerts.map((alert,index) =>(
            <div style={{
              backgroundColor: "#f8fafc",
              borderRadius: "2px",
              marginBottom: "16px",
              maxWidth:"100%",
              width:isMobile?"100%":"auto",
            }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "20px",
                  padding: "12px 14px",
                  backgroundColor: "#F4F4F4",
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                  border: "1px solid #E2E5ED",

                }}
              >
                <span style={{ fontSize: "14px", color: "#324054", fontWeight: 500 }}>Alert Level {alert.level}</span>
                <Toggle
                  checked={kitToConfigure.alerts[alert.level]}
                  onChange={()=>toggleThresholdSettings(alert.level,kitToConfigure.alerts[alert.level])}
                  label=""
                  noBorder
                  noMargin
                />
                <span style={styleClasses.accordionToggle} onClick={()=>handleAccordian(alert.level)}>{(currentOpenAccordion&&currentOpenAccordion==alert.level)?'-':'+'}</span>

              </div>

              {currentOpenAccordion==alert.level && (
                <>
                  <div style={{ padding: "20px" }}>
                    <div className="slider-container" style={{ marginBottom: "24px",position:"relative" }}>
                    <RangeSlider low={alert.low} high={alert.high} handleChangeValues={(low,high)=>onSliderChange(alert.level,[low,high])} kitId={kitId} disabled={alertConfigDisabled}/>
                    </div>
                    <div style={{ display: "flex", flexDirection:isMobile?"column":"row", gap: "16px", marginBottom: "24px" }}>
                      <div>
                        <div style={{ fontSize: "12px", color: "#324054", marginBottom: "6px" }}>Alert After</div>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <input
                            type="text"
                            value={alert.currentLevelPeriod}
                            onChange={(e) => handleAlertThresholdChange("currentLevelPeriod", e.target.value, alert.level)}
                            style={{
                              width: "100%",
                              height: "100%",
                              padding: "8px 12px",
                              border: "1px solid #d1d5db",
                              borderRadius: "6px",
                              fontSize: "14px",
                              outline: "none",
                              color: "#324054"
                            }}
                          />
                          <span style={{ fontSize: "12px", color: "#868DAA" }}>mins</span>
                        </div>
                      </div>
                      <div>
                        <div style={{ fontSize: "12px", color: "#324054", marginBottom: "6px" }}>Persistence Type</div>
                        <select
                          value={alert.persistence || ""}
                          onChange={(e) => handleAlertThresholdChange("persistence", e.target.value,alert.level)}
                          style={{
                            width: "100%",
                            height: "36px",
                            padding: "8px 12px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            fontSize: "14px",
                            backgroundColor: "white",
                            color: alert.persistence ? "#324054" : "#868DAA",
                            outline: "none"
                          }}
                        >
                          <option value="" disabled hidden>
                            Select persistence type
                          </option>
                          {persistenceTypes.map((type) => (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <div style={{ fontSize: "12px", color: "#324054", marginBottom: "6px" }}>Alert Next Level After</div>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <input
                            type="text"
                            value={alert.nextLevelPeriod}
                            onChange={(e) => handleAlertThresholdChange("nextLevelPeriod", e.target.value,alert.level)}
                            style={{
                              width: "100%",
                              height: "100%",
                              padding: "8px 12px",
                              border: "1px solid #d1d5db",
                              borderRadius: "6px",
                              fontSize: "14px",
                              outline: "none"
                            }}
                          />
                          <span style={{ fontSize: "12px", color: "#868DAA" }}>mins</span>
                        </div>
                      </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: isMobile ? "center" : "flex-end", gap: "12px" }}>
                      <button
                       onClick={() => handleResetAlertLimit(alert)}
                       style={{
                        padding: "8px 20px",
                        backgroundColor: "white",
                        border: "1px solid #868DAA",
                        borderRadius: "6px",
                        color: "#868DAA",
                        fontSize: "14px",
                        cursor: "pointer",
                        fontWeight: 500
                      }}>
                        Reset
                      </button>
                      <button 
                      onClick={() => handleUpdateAlertLimit(alert)}
                      style={{
                        padding: "8px 20px",
                        backgroundColor: "#3b82f6",
                        border: "1px solid #3b82f6",
                        borderRadius: "6px",
                        color: "white",
                        fontSize: "14px",
                        cursor: "pointer",
                        fontWeight: 500
                      }}>
                        Save
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>))}
            </fieldset>
          </div>
        </div>
        </>)}
       {kitToConfigure.id &&(
        <>
        <div >
          <h3 style={{
            fontSize: "16px",
            fontWeight: 600,
            color: "#1e293b"
          }}>Threshold History</h3>
        </div>
        {/* Threshold History */}      
        <div style={{          
          width:"100%",
          overflowX:"auto",
          display: "flex",
          minHeight:"400px"}}>
        <div style={{
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          minWidth:"650px",
          width:"100%",
        }}>

         
          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
            gap: "0",
            padding: "10px 18px",
            backgroundColor: "#E2E5ED",
            borderTop: "1px solid #E2E5ED",
            borderBottom: "1px solid #E2E5ED",
            borderTopLeftRadius: "6px",
            borderTopRightRadius: "6px",
            minWidth:"650px"          }}>
            <span style={{ fontSize: "14px", fontWeight: 500, color: "#324054" }}>User</span>
            <span style={{ fontSize: "14px", fontWeight: 500, color: "#324054" }}>Threshold Level</span>
            <span style={{ fontSize: "14px", fontWeight: 500, color: "#324054" }}>Alert Level</span>
            <span style={{ fontSize: "14px", fontWeight: 500, color: "#324054" }}>Time</span>
          </div>

          {alertLimitHistory && alertLimitHistory.length > 0 && alertLimitHistory.map((row, index) => (
                    <div style={{
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              minWidth:"650px"
        }}>
            <div
              key={index}
              style={{
                                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr 1fr",
                gap: "0",
                padding: "10px 18px",             
                backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                borderBottom: index < alertLimitHistory.length - 1 ? "1px solid #E2E5ED" : "none"
              }}
            >
              <span style={styleClasses.tableCellSpan }>{row.user}</span>
              <span style={styleClasses.tableCellSpan }>Low:{row.alertLimit.low} High:{row.alertLimit.high}</span>
              <span style={styleClasses.tableCellSpan }>{row.alertLimit.level}</span>
              <span style={styleClasses.tableCellSpan }>{row.time}</span>
            </div>
            </div>
          ))}
          {alertLimitHistory && alertLimitHistory.length === 0 && (
            <div style={{ padding: "10px 18px", textAlign: "center", color: "#868DAA" }}>
              No threshold history available
            </div>
          )}
        </div></div>
        </>)}
        {kitToConfigure.id &&(
        <>
        <div >
          <h3 style={{
            fontSize: "16px",
            fontWeight: 600,
            color: "#1e293b"
          }}>Alert Toggle History</h3>
        </div>
        <div style={{          
          minWidth:isMobile?"100%":"400px",
          width:"100%",
          minHeight:"400px",
          overflowX:"scroll",
          display: "flex",
          
          }}>
        <div style={{
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          minWidth:isMobile?"650px":"100%",

        }}>
         
          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
            gap: "0",
            padding: "10px 18px",
            backgroundColor: "#E2E5ED",
            borderTop: "1px solid #E2E5ED",
            borderBottom: "1px solid #E2E5ED",
            borderTopLeftRadius: "6px",
            borderTopRightRadius: "6px",
          }}>
            <span style={{ fontSize: "14px", fontWeight: 500, color: "#324054" }}>User</span>
            <span style={{ fontSize: "14px", fontWeight: 500, color: "#324054" }}> Level</span>
            <span style={{ fontSize: "14px", fontWeight: 500, color: "#324054" }}>Alert </span>
            <span style={{ fontSize: "14px", fontWeight: 500, color: "#324054" }}>Time</span>
          </div>

          {alertToggleHistory && alertToggleHistory.length > 0 && alertToggleHistory.map((row, index) => (
            <div
              key={index}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr 1fr",
                gap: "2px",
                padding: "10px 18px",
                backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                borderBottom: index < alertToggleHistory.length - 1 ? "1px solid #E2E5ED" : "none"
              }}
            >
              <span style={styleClasses.tableCellSpan}>{row.user}</span>
              <span style={styleClasses.tableCellSpan}>Level {row.level}</span>
              <span style={styleClasses.tableCellSpan}>{row.alert?"ON":"OFF"}</span>
              <span style={styleClasses.tableCellSpan}>
                {row.time}
              </span>
            </div>
          ))}
          {alertToggleHistory && alertToggleHistory.length === 0 && (
            <div style={{ padding: "10px 18px", textAlign: "center", color: "#868DAA" }}>
              No Alert history available
            </div>
          )}
        </div></div>
        </>)}
      </div>

      {/* Right Panel */}
      <div style={styleClasses.kitRightPanel}>

        {/* Toggle Controls */}
        <div>
          <Toggle
            checked={underMaintenance}
            onChange={ handleMaintenanceToggle}
            label="Under Maintenance"
          />
          <Toggle
            checked={persistenceDevice}
            onChange={ handlePersistenceToggle}
            label="Persistence Device"
          />
          <div style={{ marginBottom: "0" }}>
            <Toggle
              checked={suppressAlerts}
              onChange={handleSuppressAlertsToggle}
              label="Suppress Alerts On Deforest"
            />
            {suppressAlerts&&(
              <div>
                        <div style={{ fontSize: "12px", color: "#324054", marginBottom: "6px" }}>Interval</div>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <input
                            type="text"
                            value={defrostInterval}
                            onChange={ (e)=>setDefrostInterval(e.target.value)}
                            style={{
                              width: "100%",
                              height: "100%",
                              padding: "8px 12px",
                              border: "1px solid #d1d5db",
                              borderRadius: "6px",
                              fontSize: "14px",
                              outline: "none"
                            }}
                          />
                          <span style={{ fontSize: "12px", color: "#868DAA" }}>mins</span>
                        </div>
                                              <button 
                      onClick={handleUpdateSupressAlert}
                      style={{
                        padding: "8px 20px",
                        backgroundColor: "#3b82f6",
                        border: "1px solid #3b82f6",
                        borderRadius: "6px",
                        color: "white",
                        fontSize: "14px",
                        cursor: "pointer",
                        fontWeight: 500
                      }}>
                        Save
                      </button>
                        </div>)}
              
            
          </div>
        </div>

        <div >
          <h3 style={{
            fontSize: "16px",
            fontWeight: 600,
            color: "#324054"
          }}>
            Maintenance History
          </h3>
        </div>

        {/* Maintenance History */}
        <div style={{  display: "flex",
          overflowX:"auto"}}>
        <div style={{
          backgroundColor: "white",
          // flex: "1",
          borderRadius: "6px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          overflowY:"auto",
          maxHeight:"250px",
          minWidth:isMobile?"400px":"100%"
        
        }}>


          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 0,
            padding: "8px 14px",
            backgroundColor: "#E2E5ED",
            borderTop: "1px solid #E2E5ED",
            borderBottom: "1px solid #E2E5ED",
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
            position:"sticky",
            top:0,
            zIndex:1
          }}>
            <span style={{ fontSize: "14px", fontWeight: 500, color: "#324054" }}>User</span>
            <span style={{ fontSize: "14px", fontWeight: 500, color: "#324054" }}>Status</span>
            <span style={{ fontSize: "14px", fontWeight: 500, color: "#324054" }}>Time</span>
          </div>

          {maintenanceHistory.length>0 && maintenanceHistory.map((row, index) => (
            <div
              key={index}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: 0,
                padding: "8px 14px",
                backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                borderBottom: index < maintenanceHistory.length - 1 ? "1px solid #E2E5ED" : "none"
              }}
            >
              <span style={{ fontSize: "14px", color: "#324054", fontWeight: 400 }}>{row.user}</span>
              <span style={{
                fontSize: "14px",
                fontWeight: 500,
                color: "#324054"
              }}>{row.maintain ? 'ON' : 'OFF'}</span>
              <span style={{
                fontSize: "12px",
                color: "#324054",
                fontWeight: 400,
                whiteSpace: "pre-line",
                lineHeight: "1.3"
              }}>{row.time}</span>
            </div>
          ))}
          {maintenanceHistory && maintenanceHistory.length === 0 && (
            <div style={{ padding: "10px 18px", textAlign: "center", color: "#868DAA" }}>
              No Maintenance history available
            </div>
          )}

          
        </div>
        </div>
      <Toaster open={openToaster} isSuccess={success} msg={msg}/>
      </div>
    </div>
  );
};

export default KitsConfiguration;




const RangeSlider=({low,high,handleChangeValues,kitId,disabled})=>{
 const [min, setMin] = React.useState(low - 10);
  const [max, setMax] = React.useState(high + 10);

  React.useEffect(() => {
    // reset when kit changes
    setMin(low - 10);
    setMax(high + 10);
  }, [kitId]);

  React.useEffect(() => {
    if (low - min <= 1 ||low-min>20) {
      setMin(low - 5); 
    }

    if (max - high <= 1||max-high>20) {
      setMax(high + 5); 
    }
  }, [low, high]); 


  return  <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          margin: "2em"
        }}
      >
        <Range
          disabled={disabled}
          values={[low,high]}
          step={1}
          min={min}
          max={max}
          onChange={([low,high]) => {handleChangeValues(low,high)}}
          renderTrack={({ props, children }) => (
            <div
              onMouseDown={props.onMouseDown}
              onTouchStart={props.onTouchStart}
              style={{
                ...props.style,
                height: "36px",
                display: "flex",
                width: "100%"
              }}
            >
              
              <div
                ref={props.ref}
                style={{
                  height: "5px",
                  width: "100%",
                  borderRadius: "4px",
                  
                  background: getTrackBackground({
                    values: [low,high],
                    colors: ["#7495aeff","#548BF4", "#7495aeff"],
                    min: min,
                    max: max
                  }),
                  alignSelf: "center"
                }}
              >
                {children}
              </div>
            </div>
          )}
          renderThumb={({index, props, isDragged }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: "20px",
                width: "20px",
                borderRadius: "4px",
                backgroundColor: "#FFF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0px 2px 6px #AAA"
              }}
            >
                          <div
              style={{
                position: "absolute",
                top: "-28px",
                color: "#fff",
                fontWeight: "bold",
                fontSize: "14px",
                fontFamily: "Arial,Helvetica Neue,Helvetica,sans-serif",
                padding: "4px",
                borderRadius: "4px",
                backgroundColor: "#548BF4",
              }}
            >
              {[low,high][index]}
            </div>
              <div
                style={{
                  height: "16px",
                  width: "5px",
                  backgroundColor: isDragged ? "#548BF4" : "#CCC"
                }}
              />
            </div>
          )}
        />
      </div>
}
